/**
 * Created with IntelliJ IDEA.
 * User: ffischer
 * Date: 19.04.13
 * Time: 16:06
 */

/********************************************************************************
 /*    These definitions are used from client, server and backend.                    *
 /*    Think twice, if you want to change something.                                *
 /*    Look at the documentation under:                                            *
 /********************************************************************************/
/**
 * Constants for private offer definition names
 */
export class Constants_Offer {
    // offer descriptions
    public static VISUAL_COMPONENT_CONTAINER: string = "visualComponents";
    public static REWARD_COMPONENT_CONTAINER: string = "rewardComponents";
    public static OFFER_COST_C1: string = "costCurrencyNormal";
    public static OFFER_COST_C2: string = "costCurrencyPremium";
    public static OFFER_COST_EMPIRE_RESOURCES: string = "costEmpireResources";
    public static OFFER_AUTO_ACCEPT: string = "autoAccept";

    // offer quest conditions
    public static QUEST_CONDITION_CONTAINER: string = "conditions";
    public static QUEST_CONDITION_INTEGER_PLAYER_LEVEL: string = "playerLevel";

    // offer description reward components Empire
    public static OFFER_REWARD_BOOSTER: string = "booster";
    public static OFFER_REWARD_EXTINGUISH_FIRE: string = "extinguishFire";
    public static OFFER_REWARD_EMPIRE_STANDARD: string = "standardReward";

    // offer description reward components Ranch
    public static OFFER_REWARD_ITEM_REWARD: string = "itemReward";

    // offer description visual components
    public static OFFER_VISUAL_FAILED_DIALOG: string = "failedDialog";
    public static OFFER_VISUAL_FINISH_DIALOG: string = "finishDialog";
    public static OFFER_VISUAL_QUEST_DIALOG: string = "questDialog";
    public static OFFER_VISUAL_QUEST_ACCEPT_DIALOG: string = "questAcceptDialog";
    public static OFFER_VISUAL_OFFER_DIALOG: string = "offerDialog";

    public static OFFER_VISUAL_REWARD_SLOT_ORDER: string = "rewardSlotOrder";
    public static OFFER_VISUAL_ISO_OBJECT: string = "isoObject";
    public static OFFER_VISUAL_INTERFACE_BUTTON: string = "interfaceButton";
}
